<template>
    <div>
        <router-link :to="`/day-wallets/settlement-detail/${row.id}`">
            <i class="fas fa-cog"></i>
        </router-link>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
        },
    })
</script>
